import PaymentsInfoConfirmationForm from './PaymentsInfoConfirmationForm';

export default PaymentsInfoConfirmationForm;
